import { InferType, object } from 'yup';
import { LoginResponse } from '../../../compiled_proto/com/celertech/baseserver/communication/login/DownstreamLoginProto';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const loginSchema = (userRequires2FA?: LoginResponse) =>
    object({
        username: safeString().required('Username cannot be empty!'),
        password: safeString().required('Password cannot be empty!'),
        twoFactorToken: safeString()
            .optional()
            .test('noEmptyTwoFactorToken', 'Verification Code should not be empty.', (token) => {
                if (userRequires2FA && !token) return false;
                return true;
            })
    });

export type LoginFormValues = InferType<ReturnType<typeof loginSchema>>;
export type LoginFormInput = Nullable<LoginFormValues>;
